import { render, staticRenderFns } from "./UnitDashboardBuilder.vue?vue&type=template&id=39559442&scoped=true&"
import script from "./UnitDashboardBuilder.vue?vue&type=script&lang=js&"
export * from "./UnitDashboardBuilder.vue?vue&type=script&lang=js&"
import style0 from "./UnitDashboardBuilder.vue?vue&type=style&index=0&id=39559442&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39559442",
  null
  
)

component.options.__file = "UnitDashboardBuilder.vue"
export default component.exports